import { render, staticRenderFns } from "./resourcesEssential.vue?vue&type=template&id=2eaea2f6"
import script from "./resourcesEssential.vue?vue&type=script&lang=js"
export * from "./resourcesEssential.vue?vue&type=script&lang=js"
import style0 from "./resourcesEssential.vue?vue&type=style&index=0&id=2eaea2f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports